<template>
  <div id="app">
    <router-view></router-view>
    <!-- <playerMask v-show="showa1" @tocancel="okfall"></playerMask> -->
    <!-- <div style="position:fixed;top:100px;left:0;font-size:12px;">{{resultData}}</div> -->
    <section style="display: none">
      <span id="mobile"></span>
      <span id="mobile1"></span>
      <span id="mobile2"></span>
      <span id="mobile3"></span>
      <span id="mobile4"></span>
      {{ resultData1 }}
      {{ resultData2 }}
      {{ resultData5 }}
      {{ resultData3 }}
      {{ resultData4 }}
      {{ resultData5 }}
      {{ aaab }}
      {{ aaab1 }}
    </section>
    <!-- <div style="position: fixed; top: 300px; left: 0">{{ cs1 }}</div> -->
    <!-- <div style="position:fixed;top:100px;left:0;width: 100px;font-size:12px;">{{resultData.data.hhlz_uid}}</div> -->
  </div>
</template>

<script>
// import utils from './plugin/utils'
// var ver = utils.getUrlKey('ver')
import { mapState, mapMutations, mapActions } from "vuex";
// import Loading  from './components/Module/loading'
// import playerMask from "./components/player";
import { scriptInsert } from "././plugin/tools";
export default {
  // components: { playerMask },
  name: "app",
  computed: {
    ...mapState("userIndex", [
      "showa1",
      "UserData",
      "Token",
      "Userid",
      "verNum",
    ]),
  },
  data() {
    return {
      resultData: null,
      resultToken: null,
      resultData1: null,
      resultData2: null,
      resultData3: null,
      resultData4: null,
      count: 0,
      aaab: null,
      aaab1: null,
      appIdNum: null,
      resultData5: null,
      cs1: null,
      // test:null,
      // UserId:null,
    };
  },
  watch: {
    resultData() {
      this.count = this.count + 1;
    },
  },
  created() {
    // setTimeout(() => {
    //   this.setverNum(229);
    //   this.detailLink();
    // }, 1000)
    // this.setUserData({
    //   user_mobile: 13888888888,
    //   user_source: "2"
    // })

    // scriptInsert("https://hm.baidu.com/hm.js?4f4be451b9e8955c17be72f3c6c1e792");
    // scriptInsert("https://w.cnzz.com/c.php?id=5f8d071e80455950e4ae12bb");
    if (window && window.android) {
      // 登陆
      var result = window.android.getToken();
      this.resultData = JSON.parse(result);
      this.setUserData(this.resultData.data);
      this.setToken(this.resultData.token);
      if (this.resultData.token) {
        let hhver =
          this.resultData.data.hhlz_ver
            .replace(/[a-zA-Z]/g, (match, i) => match.charCodeAt())
            .replace(/[^\d]/g, "") - 0;
        if (parseInt(hhver) >= 228) {
          var result1 = window.android.getSaServerAppId();
          this.appIdNum = result1;
          this.setappId(this.appIdNum);
          this.sensors.login(
            `${this.appIdNum}_${this.resultData.data.hhlz_uid}`
          );
          this.aaab =
            this.resultData.data.hhlz_ver
              .replace(/[a-zA-Z]/g, (match, i) => match.charCodeAt())
              .replace(/[^\d]/g, "") - 0;
          this.aaab1 = result1;
          this.setverNum(this.aaab);
          // this.detailLink();
          // if (parseInt(this.aaab) >= 228) {
          this.sensors.init({
            server_url: "https://shence.jiushengliye.com/sa?project=YDA44",
            // server_url: "https://shence.jiushengliye.com/sa?project=YDA44TEST",
            heatmap: {
              //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
              clickmap: "not_collect",
              show_log: true,
              //是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
              scroll_notice_map: "not_collect",
            },
          });
        }
        // }
      }
      // }
      //  退出登陆
      window.android.thirdpartyLogout();
    }
    // //ios
    // const that = this;
    if (window && window.webkit && window.webkit.messageHandlers) {
      window.webkit.messageHandlers.getToken.postMessage(
        function (data) {
          // document.getElementById('mobile').innerText=JSON.parse(data).token;
          document.getElementById("mobile1").innerText = JSON.stringify(
            JSON.parse(data).data
          );
          document.getElementById("mobile").innerText = JSON.parse(data).token;
          document.getElementById("mobile2").innerText = JSON.stringify(
            JSON.parse(data).data.hhlz_uid
          );
          document.getElementById("mobile3").innerText = JSON.stringify(
            JSON.parse(data).data.hhlz_ver
          );
          window.webkit.messageHandlers.getSaServerAppId.postMessage(
            function (data) {
              document.getElementById("mobile4").innerText = data;
            } + ""
          );
          // document.getElementById('mobile1').innerText= JSON.parse(data).data
        } + ""
      );
      setTimeout(() => {
        this.resultData1 = document.getElementById("mobile").innerText;
        this.setToken(this.resultData1);
        this.resultData2 = document.getElementById("mobile1").innerText;
        this.setUserData(JSON.parse(this.resultData2));
        // if (this.resultData1) {
        // setTimeout(() => {
        this.resultData4 = document.getElementById("mobile3").innerText;
        this.aaab =
          this.resultData4
            .replace(/[a-zA-Z]/g, (match, i) => match.charCodeAt())
            .replace(/[^\d]/g, "") - 0;
        this.setverNum(this.aaab);
        // this.detailLink();
        if (parseInt(this.aaab) >= 228) {
          this.resultData5 = document.getElementById("mobile4").innerText;
          this.setappId(this.resultData5);
          let uuid = document.getElementById("mobile2").innerText;
          this.resultData3 = uuid.replace(/(^\"*)|(\"*$)/g, "");
          this.sensors.login(`${this.resultData5}_${this.resultData3}`);
          this.sensors.init({
            server_url: "https://shence.jiushengliye.com/sa?project=YDA44",
            // server_url: "https://shence.jiushengliye.com/sa?project=YDA44TEST",
            heatmap: {
              //是否开启点击图，default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭。
              clickmap: "not_collect",
              show_log: true,
              //是否开启触达注意力图，not_collect 表示关闭，不会自动采集 $WebStay 事件，可以设置 'default' 表示开启。
              scroll_notice_map: "not_collect",
            },
          });
        }
        // }, 1000);
        // }
        // }
      }, 1000);
      //  退出登陆
      window.webkit.messageHandlers.thirdpartyLogout.postMessage({});
    }
    scriptInsert("https://hm.baidu.com/hm.js?a0a0e0b46376dd34be832b9f4c589771");
  },
  mounted() {
    this.detailLink();
  },
  methods: {
    ...mapMutations("userIndex", [
      "setShowa1",
      "setUserData",
      "setToken",
      "setUserid",
      "setverNum",
      "setappId",
    ]),
    detailLink() {
      // if (this.verNum >= 229) {
        let _this = this;
        /**
         * ncid 当前章节id
         * nid 小说 id
         * acname 小说标题
         * current_time 可选 当前播放的时间
         */
        window.toPlayDetail = function (ncid, nid, acname, current_time) {
          let routeObj = {
            path: "/player",
            query: {
              ncid,
              nid,
              acname,
              current_time,
              ver: _this.verNum,
            },
          };
          if (_this.$route.path === "/player") {
            routeObj.path = "/h";
            _this.$router.replace(routeObj);
          } else {
            _this.$router.push(routeObj);
          }
        };
      // }
    },
    // okfall() {
    //   this.setShowa1(false);
    // },
  },
};
</script>
